import { useNavigate } from 'react-router'

import { useLogout } from '@/auth/queries'

export function useSignOut(): { signOut: () => void; isPending: boolean } {
  const logout = useLogout()
  const navigate = useNavigate()

  const signOut = (): void => {
    logout.mutate({}, { onSettled: () => navigate('/login', { replace: true }) })
  }

  return { signOut, isPending: logout.isPending }
}
